import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getPriceList } from "src/service/pay";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { payPlanInfoAtom } from "src/atoms";
import { ProductKey } from "src/config/config";
import { useParams, useSearchParams } from "react-router-dom";

interface IUseTotalNxacListProps {
  product: ProductKey;
  status?: "REAL" | "TEST";
  // currency: string; // 원화 정보
  onSuccess?: () => void;
  onError?: () => void;
}
// 제품별 요금제 정보
export function useGetPriceList({
  product,
  status = "REAL",
  onSuccess,
  onError,
}: IUseTotalNxacListProps) {
  const { handleError } = useApiError();
  const [params, setParams] = useSearchParams();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const [payPlanInfo, setPayPlanInfo] = useRecoilState(payPlanInfoAtom);
  // 상품별 요금제 정보
  // const [isPriceListLoading, setIsPriceListLoading] = useState<boolean>(true);

  const {
    isLoading: isPriceListLoading,
    data: priceList,
    refetch: priceListRefetch,
  } = useQuery(
    ["getPriceList", `${product}`],
    async () =>
      await getPriceList({
        status,
        product: [product],
      }),
    {
      enabled: product !== null,
      // refetchOnMount: true,
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: onError ? onError : handleError,
    }
  );

  return { isPriceListLoading, priceList, priceListRefetch };
}
